import { useRecordContext, useTranslate } from "ra-core";

import { StatusPill } from "../design/StatusPill";
import type { Project } from "../types";
import { complianceStatusToPill } from "./complianceStatus";

/**
 * Renders a project's `compliance_pack_status` as a StatusPill (Almikia
 * design-system.md section 3: binary states always render as a green/red
 * semaforo with icon and text, never color alone). To be used inside a
 * `<DataTable.Col>` or anywhere a `Project` record context is available.
 */
export const ComplianceStatusPill = () => {
  const record = useRecordContext<Project>();
  const translate = useTranslate();
  if (!record) return null;

  const { tone, messageKey } = complianceStatusToPill(
    record.compliance_pack_status,
  );

  return (
    <StatusPill
      tone={tone}
      text={
        messageKey
          ? translate(messageKey)
          : String(record.compliance_pack_status ?? "—")
      }
    />
  );
};
